import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateTicketComponent } from 'src/app/tickets/containers';

import * as Orders from '../models';
import OrderContactInfo from '../order-contacts-box/order-contact-info.interface';
import OrderInfoDetail from '../order-info.interface';

@Component({
  selector: 'app-view-order',
  templateUrl: './view-order.component.html',
  standalone: false,
})
export class ViewOrderComponent implements OnInit {
  @Input() order: Orders.Order = null;

  @Input() otherSites: Orders.Order[] = [];

  @Output() selectOrder: EventEmitter<Orders.Order> = new EventEmitter();

  @Output() back: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;

  datesInCenter: boolean = false;

  generalInfo: OrderInfoDetail[];

  basicServiceInfo: OrderInfoDetail[];

  keyDates: OrderInfoDetail[];

  circuitOrdersInfo: OrderInfoDetail[];

  contactsInfo: OrderContactInfo[];

  private location = inject(Location);

  private dialog = inject(MatDialog);

  ngOnInit(): void {
    this.updateUrl();
    this.getAllInfo();
    if (
      this.order.type === Orders.OrderType.VOICE ||
      this.order.type === Orders.OrderType.SDWAN
    ) {
      this.datesInCenter = true;
    }
  }

  private updateUrl(): void {
    this.location.replaceState(`/orders-table/${this.order.id}/view`);
  }

  private getAllInfo(): void {
    if (!this.order) return;
    this.generalInfo = this.order.getGeneralInformation();
    this.basicServiceInfo = this.order.getBasicServiceInfo();
    this.keyDates = this.order.getDates();
    this.circuitOrdersInfo = this.order.getCircuitOrderInfo();
    this.contactsInfo = this.order.getContactsInfo();
  }

  goBack(): void {
    this.location.replaceState('/orders-table');
    this.back.emit();
  }

  openOtherOrder(order: Orders.Order): void {
    this.selectOrder.emit(order);
  }

  async onCreateTicket(): Promise<void> {
    const browserSize = window.innerWidth <= 700 ? 'small' : '';
    // open modal
    const dialogConfig = {
      autoFocus: true,
      minHeight: browserSize === 'small' ? '315px' : '380px',
      width: browserSize === 'small' ? 'calc(100vw - 20px)' : '650px',
      maxWidth: '650px',
      data: {
        browserSize,
        originPage: 'Service',
      },
      disableClose: true,
    };
    this.dialog.open(CreateTicketComponent, dialogConfig);
  }
}
